import router from '@/router';
import Vue from 'vue';

const contextUIModule = {
  namespaced: true,
  modules: {},
  state: () => ({
    dragging: false,
    animating: false,
    hoveringItem: {
      id: null,
      type: null
    },
    editingQuestionId: null,
    selectedPageId: 'contextTitle',
    focusedContainer: null,
    highlightedItems: [],
    showResourcePanel: false,
    resourcePanelView: 0,
    showQuestionList: true,
    //  new
    resourceViewer: {
      show: false,
      resourceId: null,
      width: 50
    },
    selectedNoteBlocks: [],
    openNotes: {}
  }),
  getters: {},
  mutations: {
    setSelectedNoteBlocks(state, val) {
      state.selectedNoteBlocks = val;
    },
    setOpenNotes(state, { noteId, val }) {
      Vue.set(state.openNotes, noteId, val);
    },
    setDragging(state, val) {
      state.dragging = val;
    },
    setAnimating(state, val) {
      state.animating = val;
    },
    setHoveringItem(state, val) {
      state.hoveringItem = val;
    },
    setEditingQuestionId(state, val) {
      state.editingQuestionId = val;
    },
    setSelectedPageId(state, val) {
      console.log(router);
      const { currentRoute } = router;
      if (val) {
        const { page, addCrumb, removeCrumbsIndex } = val;
        const route = { name: currentRoute.name, params: { ...currentRoute.params, page } };
        if (addCrumb) {
          const q = currentRoute.query;
          let crumb = q.crumb ? q.crumb + '-' : '';
          crumb = crumb + currentRoute.params.page;
          route.query = { crumb };
        }
        if (removeCrumbsIndex != undefined) {
          let crums = currentRoute.query.crumb.split('-');
          crums = crums.slice(0, removeCrumbsIndex);
          route.query = { crumb: crums.join('-') };
        }
        router.push(route);
      } else {
        router.push({
          name: currentRoute.name,
          params: { contextId: currentRoute.params.contextId }
        });
      }

      state.selectedPageId = val ? val.page : null;
    },
    setFocusedContainer(state, val) {
      state.focusedContainer = val;
    },
    removeItemFromHighlightedItems(state, id) {
      const i = state.highlightedItems.indexOf(id);
      if (i !== -1) {
        state.highlightedItems.splice(i, 1);
      }
    },
    addItemToHighlightedItems(state, id) {
      state.highlightedItems.push(id);
    },
    setResourceViewer(state, { show, resourceId, width }) {
      if (show != undefined) {
        Vue.set(state.resourceViewer, 'show', show);
      }
      if (resourceId != undefined) {
        Vue.set(state.resourceViewer, 'resourceId', resourceId);
      }
      if (width != undefined) {
        Vue.set(state.resourceViewer, 'width', width);
      }
    },
    setHighlightedItems(state, v = []) {
      state.highlightedItems = v;
    },
    setShowResourcePanel(state, view) {
      state.showResourcePanel = view;
    },
    setResourcePanelView(state, view) {
      state.resourcePanelView = view;
    },
    setShowQuestionList(state, val) {
      state.showQuestionList = val;
    }
  }
};

export default contextUIModule;
